import Vue from 'vue'
import VueRouter from 'vue-router'

import NProgress from 'nprogress' // Progress 进度条
import 'nprogress/nprogress.css'// Progress 进度条样式
Vue.use(VueRouter);


import Login from '../components/login/login.vue'

//import file from './file.js';             // 档案管理
//import resource from './resource.js';     // 资源管理
//import authority from './authority.js';   // 权限管理

import system from './system.js';   // 系统管理
import landtax from './landtax.js';
import  contract from './contract.js'

import laws from "~/router/laws";
import report from "~/router/report";   // 管理

const router =new VueRouter({
  routes: [
    {
      path: '/',
      redirect: '/login'
    },

      { //跳转中间页面
          path: '/redirect',
          name: 'redirect',
          component: resolve => require(['../components/views/redirect/redirect.vue'], resolve),
      },

      { //初始化导航
          path: '/navigation',
          name: 'navigation',
          component: resolve => require(['../components/views/init/navigation.vue'], resolve),
      },


      { //登录页
      path: '/login',
      name: 'Login',
      component: Login
    },

      { //登录页
          path: '/resetPassword',
          name: 'resetPassword',
          component: resolve => require(['../components/resetPassword/index.vue'], resolve),
      },




    { //管理系统导航页
      path: '/home',
      name: 'home',
      component: resolve => require(['../components/home.vue'], resolve),

        children:[




            {
                path: '/',
                name: 'contract',
                redirect: '/home/contract',
                component: resolve => require(['../components/views/contract/contractMain.vue'], resolve),
            },


            {
                path: '/home/contract',
                name: 'landtaxindex',
                component: resolve => require(['../components/views/contract/contractMain.vue'], resolve),

                children:[ ...contract ]

            },

            {
                path: '/home/report',
                name: 'reportindex',
                component: resolve => require(['../components/views/report/reportMain.vue'], resolve),

                children:[ ...report ]

            },


            {
                path: '/home/system',
                name: 'systemIndex',
                component: resolve => require(['../components/views/system/systemIndex.vue'], resolve),
                children: [...system]

            }

  ]
    }

      ]


})


router.beforeEach((to, from, next) => {
    NProgress.start()
    console.log("to:"+to.path)
    var session_key= sessionStorage.getItem('session_key');//获取浏览器缓存的用户信息
    if(session_key != null || to.fullPath=='/redirect' || to.fullPath == '/navigation'){//如果有就直接到首页咯
        next();
    }else{
        if(to.path=='/login'){//如果是登录页面路径，就直接next()
            next();
        }else{//不然就跳转到登录；
          //  next('/login');
            next();
        }

    }
    next()
})

router.afterEach(() => {
    NProgress.done()
})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js